/**
 * Ant Design ConfigProvider 테마 — 토큰 기반 빌드
 */
import type { ThemeConfig } from 'antd';
import { brand, gray, state, font, radius, shadow, color, space } from './tokens';

export { brand, gray, state, font, radius, shadow, color, space, tokens } from './tokens';

export const antdTheme: ThemeConfig = {
  token: {
    // Brand
    colorPrimary: brand.primary,
    colorInfo: brand.primary,
    colorLink: brand.primary,
    colorSuccess: state.success,
    colorWarning: state.warning,
    colorError: state.error,

    // Typography
    fontSize: font.size.base,
    fontFamily: font.family,

    // Radius
    borderRadius: radius.md,
    borderRadiusLG: radius.lg,
    borderRadiusSM: radius.sm,

    // Spacing
    padding: space.base,
    paddingLG: space.lg,

    // Background
    colorBgContainer: color.bg,
    colorBgLayout: color.bgLayout,
    colorBgElevated: color.bgElevated,

    // Border
    colorBorder: color.border,
    colorBorderSecondary: color.borderSubtle,

    // Text
    colorText: color.text,
    colorTextSecondary: color.textSecondary,
    colorTextTertiary: color.textTertiary,
    colorTextQuaternary: gray[300],

    // Shadow
    boxShadow: shadow.md,
    boxShadowSecondary: shadow.lg,
  },
  components: {
    Card: {
      headerBg: color.bg,
      paddingLG: space.lg,
    },
    Table: {
      headerBg: gray[50],
      headerColor: gray[600],
      rowHoverBg: gray[50],
      borderColor: gray[100],
    },
    Menu: {
      darkItemBg: 'transparent',
      darkItemSelectedBg: 'rgba(99,102,241,0.35)',
      darkItemSelectedColor: '#ffffff',
      darkItemHoverBg: 'rgba(255,255,255,0.08)',
      darkItemHoverColor: '#ffffff',
      darkItemColor: 'rgba(203,213,235,0.75)',
      darkSubMenuItemBg: 'transparent',
      itemSelectedBg: brand.primarySoftBg,
      itemSelectedColor: brand.primary,
      itemHoverBg: 'rgba(79,70,229,0.04)',
      itemHoverColor: brand.primary,
    },
    Button: {
      primaryShadow: brand.primaryShadow,
      defaultBorderColor: color.border,
    },
    Input: {
      activeBorderColor: brand.primary,
      hoverBorderColor: brand.primaryHover,
      activeShadow: `0 0 0 3px ${brand.primaryRing}`,
    },
    Form: {
      labelColor: gray[600],
      labelFontSize: font.size.sm,
    },
    Tabs: {
      inkBarColor: brand.primary,
      itemActiveColor: brand.primary,
      itemSelectedColor: brand.primary,
      itemHoverColor: brand.primaryHover,
    },
    Descriptions: {
      labelBg: gray[50],
    },
  },
};
